import { useQuery } from '@tanstack/react-query';
import { getLimits } from '../requests';
import { CACHE_TIME_10_MINUTES, CACHE_TIME_5_MINUTES } from '@/shared/config';

interface UseLimitsOptions {
  baseAsset: string;
  enabled?: boolean;
}

export function useLimits({ baseAsset, enabled = true }: UseLimitsOptions) {
  const queryKey = ['profile', 'limits', baseAsset];

  const query = useQuery({
    queryKey,
    queryFn: () => getLimits(baseAsset),
    enabled: !!baseAsset && enabled,
    staleTime: CACHE_TIME_5_MINUTES,
    gcTime: CACHE_TIME_10_MINUTES,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    status: query.status,
  };
}
